import React, { useState, memo } from "react";
import IconWithArr from "../../components/IconOrbit/IconWithArr";
import { ArrWithTechnologyOrbit } from "./config";
import { Flex, Text, Box, useMatchBreakpoints } from "@edricphan2022/uikit";
import { BoxTechnogyOrbit } from "./style";
import FexLayout from "../../components/LayoutFlex";
import styled from "styled-components";

const WithTechnologyOrbit: React.FC = () => {
  const [isArrTech] = useState(ArrWithTechnologyOrbit);
  const { isTablet, isDesktopL } = useMatchBreakpoints();

  return (
    <BoxTechnogyOrbit>
      <BoxWapper>
        {isArrTech.map((_item, _index) => (
          <BoxGroup>
            <BoxIcon>
              <Box>
                <img src={_item.icon} alt="" />
              </Box>
            </BoxIcon>
            <h3>{_item.title}</h3>
            <p>{_item.des}</p>
          </BoxGroup>
        ))}
      </BoxWapper>
    </BoxTechnogyOrbit>
  );
};

const BoxWapper = styled(Flex)`
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
`;
const BoxGroup = styled(Box)`
  width: 24%;
  max-width: 405px;
  background: #ffffff;
  padding: 20px 17px;
  border-radius: 15px;
  border: 1px solid #e7e7e8;
  min-height: 333px;
  margin-bottom: 14px;
  h3 , p{
    margin-bottom: 27px;
    font-size: 20px;
    font-weight: 700;
    font-family: ManropeBold;
    color: #333333;
  }
  p{
    font-size: 16px;
    font-family: ManropeRegular;
    font-weight: 400;
    margin-bottom : 0px;
  }
  @media only screen and (max-width: 1133px) {
    padding: 12px 12px;
    p , h3{
      font-size: 14px;
    }
  }
  @media only screen and (max-width: 743px) {
    width: 49%;
  }
  @media only screen and (max-width: 345px){
    min-height: 360px;
  }
`;
const BoxIcon = styled(Box)`
  position: relative;
  margin-bottom: 36px;
  :after {
    content: "";
    position: absolute;
    width: 188px;
    height: 86px;
    background: linear-gradient(
      90deg,
      rgba(255, 237, 155, 0.5) 12.79%,
      rgba(247, 218, 87, 0) 69.15%
    );
    top: 0px;
    left: 40px;
    z-index: 0;
  }
  div {
    width: 86px;
    height: 86px;
    background-color: #f7da57;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 30px;
    position: relative;
    z-index: 1;
  }
`;

export default memo(WithTechnologyOrbit);
